<template>
  <nuxt-link class="button" :to="to" :class="[{ enable: enable }]">
    <span class="icon-wrapper">
      <Icon class="icon-off" :name="iconName" size="2.4rem" />
      <Icon class="icon-over" :name="iconName" size="2.4rem" />
    </span>
  </nuxt-link>
</template>
<script setup lang="ts">
interface Props {
  to: string;
  enable?: boolean;
  next?: boolean;
}

const props = defineProps({
  to: null,
  enable: { type: Boolean, default: true },
  next: { type: Boolean, default: false }
});

const iconName = computed(() => (props.next ? 'nextSmall' : 'previousSmall'));
</script>
<style lang="scss" scoped>
.icon-over {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(50%) scale(0);
  transition: transform 200ms $ease-in-quad, opacity 100ms $ease-in-quad;
  opacity: 0;
}
.icon-off {
  transition: transform 200ms $ease-out-quad, opacity 100ms $ease-out-quad;
}

.button {
  --color_positive: var(--color_neutral_100);
  --color_negative: var(--color_neutral_50);

  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  overflow: hidden;
  border-radius: 50%;
  border-color: var(--color_positive);
  background: var(--color_negative);
  color: var(--color_neutral_100);
  &.enable {
    color: var(--color_neutral_500);
    pointer-events: auto;

    &:hover,
    &:focus {
      .icon-over {
        transform: translateY(-50%) translateX(-50%) scale(1);
        transition: transform 300ms $ease-out-quad, opacity 200ms $ease-out-quad;
        opacity: 1;
        color: var(--color_primary);
      }
      .icon-off {
        transform: translateX(-100%) scale(0);
        transition: transform 200ms $ease-in-quad, opacity 100ms $ease-in-quad;
        opacity: 0;
      }
    }
  }
}
.icon-wrapper {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .icon {
    pointer-events: none;
  }
}
</style>
